UIkit.util.ready(function () {
    var mobileBtn = document.getElementById("mobileBurgerBtn");
    var mobileCloseBtn = document.getElementById("mobileBurgerCloseBtn");
    var fakeMobileButton = document.getElementsByClassName("fake-button");

    // UIkit.util.on('#mobileMainMenu', 'show', function () {
    //    UIkit.util.addClass(mobileBtn, 'uk-hidden');
    //    UIkit.scroll('#mobileBurgerBtn').offset = 0;
    //    UIkit.util.removeClass(mobileCloseBtn, 'uk-hidden');
    // });

    UIkit.util.on('#mobileMainMenu', 'hidden', function (item) {
        if (item.target.id === "mobileMainMenu") {

            UIkit.util.removeClass(mobileBtn, 'uk-hidden');
            UIkit.util.addClass(mobileCloseBtn, 'uk-hidden');
        }

    });





    $("#mobileBurgerBtn").click(function () {
        UIkit.util.addClass(mobileBtn, 'uk-hidden');
        UIkit.scroll('#mobileBurgerBtn').offset = 0;
        UIkit.util.removeClass(mobileCloseBtn, 'uk-hidden');
    });

    $("#filterBtn").click(function () {
        UIkit.util.addClass(mobileBtn, 'uk-hidden');
        UIkit.scroll('#mobileBurgerBtn').offset = 0;
        UIkit.util.removeClass(mobileCloseBtn, 'uk-hidden');
      

    });

  UIkit.util.on('#js-scroll-trigger', 'scrolled', function () {
 });

  

});





// UIkit.dropdown(element, options);
 

var thumbListHolder = $('#thumbListHolder');


$(".clicker").click(function (item) {
    var thumbListHoldercroll = thumbListHolder.scrollTop();
    thumbListHolder.animate({
        scrollTop: thumbListHoldercroll + 136
    }, 500);

});

$(".clickerDown").click(function (item) {

    var thumbListHoldercroll = thumbListHolder.scrollTop();
    thumbListHolder.animate({
        scrollTop: thumbListHoldercroll - 136
    }, 500);

});

// For video player
//return a DOM object
var video = document.getElementById('myVideo'); //or

$('.btnPlay').on('click', function () {

    $('.video-holder').addClass('video-on');

    video.paused ? video.play() : video.pause();
    return false;
});



// for responsive media
function resize() {
    if ($(window).width() < 575) {
        $('html').addClass('mobile');
        $("#heroSlider").attr("uk-height-viewport", "offset-top: true");
        $("#meetTheBrand").attr("uk-slider", "finite: true");

    } else if ($(window).width() <= 768) {
        $("#meetTheBrand").attr("uk-slider", "finite: true");
    }
    else {
        $('html').removeClass('mobile');
        $("#heroSlider").removeAttr("uk-height-viewport", "offset-top: true");
        $("#meetTheBrand").removeAttr("uk-slider", "finite: true");
    }



}

$(document).ready(function () {
    $(window).resize(resize);
    resize();


    $(".product-checklist label").click(function (item) {
        $('.product-checklist li div.active').removeClass('active');
        $(this).parent().addClass('active');
    });

});


$(".button-search-header").click(function () {

    $('.mobile-search-holder').addClass('mobile-search-active');

});
$(".hide-mobile-search").click(function () {

    $('.mobile-search-holder').removeClass('mobile-search-active');

});


$(".icon-Search").click(function () {
    var icon = $(this),
        input = icon.parent().find("#search"),
        submit = icon.parent().find(".submit"),
        is_submit_clicked = false;
    icon.parent().parent().addClass('search-active');

    // Animate the input field
    input.animate({
        "width": "231px",
        "padding": "10px",
        "opacity": 1
    }, 300, function () {
        input.focus();
    });

    submit.mousedown(function () {
        is_submit_clicked = true;
    });

    // Now, we need to hide the icon too
    icon.fadeOut(300);

    // Looks great, but what about hiding the input when it loses focus and doesnt contain any value? Lets do that too
    input.blur(function () {
        if (!input.val() && !is_submit_clicked) {
            input.animate({
                "width": "0",
                "padding": "0",
                "opacity": 0
            }, 200);
            icon.parent().parent().removeClass('search-active');

            // Get the icon back
            icon.fadeIn(200);

        };
    });
});





$(function () {

    $("#searchInputBoxID").bind("keypress", function (e) {
        if (e.keyCode == 13) {
            return false;
        }
    });


    // set cookiest start here

    if (localStorage.getItem('cookieSeen') != 'shown') {
        $('.cookies-holder').show().delay(2000).fadeIn();
       
    }else{
        $('.cookies-holder').hide();
    }

    $('.cookies-set-button').click(function () {
        localStorage.setItem('cookieSeen', 'shown');
        $('.cookies-holder').fadeOut();
    });

    // set cookiest end here


  /*
  $('#search').autocomplete({
        serviceUrl: 'https://www.googleapis.com/books/v1/volumes/',
        paramName: 'q',
        deferRequestBy: 200,
        width: 320,
        showNoSuggestionNotice: true,
        noSuggestionNotice: 'No results try again',
        dataType: 'json',
        formatResult: function (suggestion, currentValue) {


            if (suggestion.data.volumeInfo.imageLinks !== undefined) {
                return '<img src=" ' + suggestion.data.volumeInfo.imageLinks.thumbnail + '" /> <div><p> ' + suggestion.data.volumeInfo.subtitle + '</p>  <em> ' + suggestion.data.volumeInfo.pageCount + '</em> </div>';
            } else {
                return '<div><p> ' + suggestion.data.volumeInfo.subtitle + '</p>  <em> ' + suggestion.data.volumeInfo.pageCount + '</em> </div>';
            }



        },
        transformResult: function (response) {
            return {
                suggestions: $.map(response.items, function (dataItem) {
                    return { value: dataItem.volumeInfo.title, data: dataItem };
                })
            };
        },
        onSelect: function (suggestion) {
            console.log('You selected: ' + suggestion.value + ', ' + suggestion.data);
        },
        onSearchStart: function () { $(this).parent().addClass('working') },
        onSearchComplete: function () { $(this).parent().removeClass('working') },
        onSearchError: function () { $(this).parent().removeClass('working'); }
    });
    */
});





$('.hero-text-holder button, .app-button, .li-link, .mobile-basket, .checkoutbtn, .createAccountButton, .logout, .login-mobile, .view-cart, .wish-link').click(function(){
  window.location.href = $(this).attr("data-href");
});

$('.li-link img, .li-link h5, .li-link h6, .li-link h1').click(function(){
  window.location.href = $(this).parent().parent().attr("data-href");
});


$('.forgot-password').click(function(e){
  e.preventDefault();
  $('.login-part').hide();
  $('.recover-part').show();
});

$('.account-back').click(function(e){
  e.preventDefault();
  $('.add-address').hide();
  $('.edit-address').hide();
  $('.main-account').show();
});
$('.addNewAddress').click(function(e){
  e.preventDefault();
  $('.main-account').hide();
  $('.edit-address').hide();
  $('.add-address').show();
});


$(".button-search-header").click(function() {

    $('.mobile-search-holder').addClass('mobile-search-active');

});
$(".hide-mobile-search").click(function() {

    $('.mobile-search-holder').removeClass('mobile-search-active');

});

 
$(".icon-Search").click(function() {
 var icon = $(this),
     input = icon.parent().find("#search"),
     submit = icon.parent().find(".submit"),
            is_submit_clicked = false;
            icon.parent().parent().addClass('search-active');
 
 // Animate the input field
 input.animate({
   "width": "231px",
   "padding": "10px",
   "opacity": 1
 }, 300, function() {
   input.focus();
 });
 
 submit.mousedown(function() {
   is_submit_clicked = true;
 });
 
 // Now, we need to hide the icon too
 icon.fadeOut(300);
 
 // Looks great, but what about hiding the input when it loses focus and doesnt contain any value? Lets do that too
 input.blur(function() {
   if(!input.val() && !is_submit_clicked) {
     input.animate({
       "width": "0",
       "padding": "0",
       "opacity": 0
            }, 200);
            icon.parent().parent().removeClass('search-active');
     
     // Get the icon back
            icon.fadeIn(200);
            
   };
 });
});
$('#currency').change(function(){
  Currency.cookie.write($(this).val());
  location.reload();
});

$(document).on("click", ".view-more-button" , function() {
   window.location.href = $(this).attr("data-href");
});


$('.uk-nav-default .no-arr').click(function(){
  window.location.href=$(this).attr("href");
});